import { useCallback, useSyncExternalStore } from "react";

// Whether a CSS media query matches now, re-rendering when that changes. For
// the rare overlay that must mount exactly ONE of two variants: CSS-hiding
// the other still leaves both mounted, each with its own focus trap, scroll
// lock and Escape listener.
export const useMediaQuery = (query: string): boolean => {
    const subscribe = useCallback(
        (onChange: () => void) => {
            const list = window.matchMedia(query);
            list.addEventListener("change", onChange);

            return () => list.removeEventListener("change", onChange);
        },
        [query],
    );

    return useSyncExternalStore(
        subscribe,
        () => window.matchMedia(query).matches,
    );
};
